module.exports = __webpack_public_path__ + "img/btn_1.e27d81c8.svg";